import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import { tcModalContent } from '../../utils/commonFormsConfig';

class TermsAndConditions extends Component {
	
	render() {
		
		return <div className='container-fluid'>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1">
                    <h1>{tcModalContent.title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1">
                    {tcModalContent.content}
                </div>
            </div>
		</div>;
	}
}

TermsAndConditions.propTypes = {
};

export default TermsAndConditions;
